///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Pipe, PipeTransform } from '@angular/core';
import { TopologyAltitudeModeEnum } from '../../../../../generated/shared-types.model';

@Pipe({
    name: 'altitudeModePipe',
    standalone: false
})
export class GtthAltitudeModePipe implements PipeTransform {
    transform(value: number): string {
        let altitudeMode: string;
        switch (value) {
            case TopologyAltitudeModeEnum.RELATIVE:
                altitudeMode = '(relative to ground)';
                break;
            case TopologyAltitudeModeEnum.ABSOLUTE:
            default:
                altitudeMode = '(absolute)';
        }
        return altitudeMode;
    }
}
